import { FC } from "react";
import styles from "./style.module.css";
import { useNavigate } from "react-router-dom";
import { DEFAULT } from "routes/route.constant";
import useSmallScreen from "utils/hooks/ui/useSmallScreen";

const NotFoundPage: FC = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(DEFAULT);
  };

  const isSmallScreen = useSmallScreen();

  return (
    <div className={styles.bgImage}>
      <div className={styles.title}>Lost your way?</div>
      <div className={styles.description}>
        Sorry, we can't find that page. You'll find lots to explore on the home
        page.
      </div>
      <div className={styles.wrapperBtn}>
        <div className={styles.button} onClick={handleRedirect}>
          Trang chủ
        </div>
      </div>
      {isSmallScreen && (
        <div className={styles.error}>
          Error code <span>404</span>
        </div>
      )}
    </div>
  );
};

export default NotFoundPage;
